import React, { Fragment, useMemo } from 'react';
export default function EmptyPlaceholder(_ref) {
  var placeholder = _ref.placeholder,
      children = _ref.children,
      node = _ref.node,
      editor = _ref.editor;
  var style = {
    position: 'absolute',
    top: 0,
    pointerEvents: 'none',
    whiteSpace: 'nowrap'
  };
  var isDefaultBlock = useMemo(function () {
    return editor.query('isDefaultBlock', editor.value.startBlock);
  }, [editor]);
  return React.createElement(Fragment, null, children, React.createElement("span", {
    style: style,
    className: "shade-30",
    contentEditable: false
  }, isDefaultBlock ? placeholder : ''));
}